import {
	GET_INSURANCE_COMPANIES,
	GET_INSURANCE_COMPANIES_SUCCESS,
	GET_INSURANCE_COMPANIES_FAIL,
	GET_INSURANCE_COMPANIES_RESET,
} from '../actions/getInsuranceCompaniesAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getInsuranceCompaniesReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_INSURANCE_COMPANIES:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_INSURANCE_COMPANIES_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_INSURANCE_COMPANIES_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_INSURANCE_COMPANIES_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getInsuranceCompaniesReducer;
